import { render, staticRenderFns } from "./Cross-Rent-Charges.vue?vue&type=template&id=665f5b04"
import script from "./Cross-Rent-Charges.vue?vue&type=script&lang=js"
export * from "./Cross-Rent-Charges.vue?vue&type=script&lang=js"
import style0 from "./Cross-Rent-Charges.vue?vue&type=style&index=0&id=665f5b04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports